module.exports = __webpack_public_path__ + "media/images/animations/axle_spacing/8-13e6a128d12a34cc9c9c45e3b40c3326.png";